import { Card } from "@/components/Card/card";
import DataTable from "@/components/DataTable/Table/DataTable";
import { defaultNS, useTranslation } from "@/lib/i18n";
import type { Table } from "@tanstack/react-table";

import type { ImportCsvError } from "../../types";

type Props<T> = {
  table: Table<T>;
  rowsCount: number;
  error: ImportCsvError;
};

const DataTableCard = <T,>({ table, rowsCount }: Props<T>) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.importCsv.dataTableCard",
  });

  return (
    <Card className="w-full flex-1 overflow-y-auto">
      {/* TODO: displayStateの適切な状態管理を確認する */}
      {rowsCount > 0 && (
        <DataTable table={table} displayState={{ state: "data" }} />
      )}
      {rowsCount == 0 && (
        <div className="flex items-center justify-center p-4 text-center">
          {t("noResult")}
        </div>
      )}
    </Card>
  );
};

export default DataTableCard;
